module.exports = __webpack_public_path__ + "static/logo-3ec22b99bf56b398db51b066ea050d36.png";